import { createAction } from '@reduxjs/toolkit';

export const setIsConnected = createAction('init/setIsConnected');
export const setModalRegisterOpen = createAction<boolean>(
  'init/setModalRegisterOpen'
);
export const setIsPartnerSetTrue = createAction('init/setIsPartnerSetTrue');
